export enum DocumentsDownloadTypes {
    Endorsement = "ENDOSO",
}

export enum DocumentTypeCorrection {
    Endorsement = "Endoso",
    Redrafting = "Reescritura",
    Renewed = "Renovación",
}

export enum DocumentTypeCorrected {
    Policy = "Póliza",
    PolicyUpdate = "Actualizaciones a tu póliza",
}
